module.exports = __webpack_public_path__ + "img/nu.300bcb7c.svg";